export class StringHelper {
  public static capitalizeFirstLetter(source: string) {
    if (!source) {
      return source;
    }
    if (typeof source !== 'string') return '';
    return source.charAt(0).toUpperCase() + source.slice(1)
  }

  public static capitalizeFirstLettersOfPropertyChain(source: string) {
    if (!source) {
      return source;
    }
    const splits = source.split('.');
    for (let i = 0; i < splits.length; i++) {
      splits[i] = this.capitalizeFirstLetter(splits[i]);
    }
    return splits.join('.');
  }
}